<load-spinner [show]="showSpinner"></load-spinner>

  <div *ngIf="manualUsageEventForm">
    <form novalidate class="form-group"
      (ngSubmit)="onSubmit()"
      [formGroup]="manualUsageEventForm">

      <!-------------------------------------------
                  Base Info
      --------------------------------------------->
      <div class="form-row form-group mb-2">

        <div class="input-group mb-2">
            <label class="col-md-4 col-form-label" for="aviClientSel">Avi Customer ID*</label>
            <div class="col-md-8">
              <ng-select
                formControlName="aviClientId"
                id="aviClientSel"
                [virtualScroll]="true"
                [items]="sharedDataService.clientParties"
                bindValue="clientParty.mailStop"
                [searchFn]="matchClientPartyRow"
                bindLabel="partyName"
                >
                <ng-template ng-option-tmp let-item="item">
                    {{item.clientParty.mailStop}} -- {{item.partyName}}
                </ng-template>
              </ng-select>
              <span class="form-control-feedback"
              *ngIf="(manualUsageEventForm.get('aviClientId').touched || manualUsageEventForm.get('aviClientId').dirty) && !manualUsageEventForm.get('aviClientId').valid">
                <span *ngIf="this.manualUsageEventForm.get('aviClientId') && this.manualUsageEventForm.get('aviClientId').errors['required']">Please select AVI Customer Id from list</span>
              </span>
            </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="billingMonthSelection">Billing Month</label>
            <div class="col-md-8">
              <select class="form-control"
                id="billingMonthSelection"
                formControlName="month">
                <option [value]='currentBillingMonth.getMonth()'>{{currentBillingMonth|date:'MMMM yyyy'}}</option>
                <option [value]='prevBillingMonth.getMonth()'>{{prevBillingMonth|date:'MMMM yyyy'}}</option>
              </select>
            </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="productSelection">Product *</label>
          <div class="col-md-8">
            <select class="form-control"
              formControlName="product"
              id="productSelection"
              [ngClass]="{'is-invalid': (manualUsageEventForm.get('product').touched || manualUsageEventForm.get('product').dirty) && !manualUsageEventForm.get('product').valid}">
              <option  [value]='' hidden disabled></option>
              <option *ngFor="let c of clientUsage" [value]="c.productDescription">{{c['productDescription']}}</option>
            </select>
            <span class="form-control-feedback"
              *ngIf="(manualUsageEventForm.get('product').touched || manualUsageEventForm.get('product').dirty) && !manualUsageEventForm.get('product').valid">
                <span *ngIf="this.manualUsageEventForm.get('product') && this.manualUsageEventForm.get('product').errors['required']">Please select Usage Product from list</span>
            </span>
            <span *ngIf="manualUsageEventForm.get('category').value">
                  <label class ="col-form-label" style="color:rgb(0, 60, 255)">Category:</label>
                  {{ manualUsageEventForm.get('category').value }}
            </span>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputDescription">Description</label>
          <div class="col-md-8">
            <input class ="form-control"
            type="text"
            id="inputDescription"
            formControlName="description"
            placeholder=""
            [ngClass]="{'is-invalid': (manualUsageEventForm.get('description').touched || manualUsageEventForm.get('description').dirty) && !manualUsageEventForm.get('description').valid}"/>
            <span class="form-control-feedback"
                *ngIf="(manualUsageEventForm.get('description').touched || manualUsageEventForm.get('description').dirty) && !manualUsageEventForm.get('description').valid">
                <span *ngIf="this.manualUsageEventForm.get('description').errors['required']">Please enter a description for this usage item.</span>
            </span>
          </div>
        </div>
      </div>

      <!-------------------------------------------
                  Site Info component
      --------------------------------------------->
      <div class="form-row form-group mb-2" formGroupName="siteGroup">
        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputSiteName">Site Name</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputSiteName"
            formControlName="siteName"/>
          </div>
        </div>
        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputSiteName">City</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputSiteName"
            formControlName="city"/>
          </div>
        </div>
        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputSiteState">State</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputSiteState"
            formControlName="state"/>
          </div>
        </div>
        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputZipcode">Zip Code</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputZipcode"
            maxlength="10"
            formControlName="zip"/>
          </div>
        </div>
      </div>

      <!-------------------------------------------
                  Open & Close info
      --------------------------------------------->
      <div class="form-row form-group mb-2" formGroupName="ocGroup"
      *ngIf= "this.manualUsageEventForm.get('usageType').value === usageEventTypes.openClose">
        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputStoreNum">Store Number</label>
          <div class="col-md-8">
            <input class="form-control"
            type="number"
            id="inputStoreNum"
            formControlName="storeNumber"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputAddress">Address</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputAddress"
            placeholder=""
            formControlName="address"/>
          </div>
        </div>

      <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputOcAccountNumber">AccountNumber</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputOcAccountNumber"
            placeholder=""
            formControlName="accountNumber"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputUtilityName">Utility Name</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputUtilityName"
            placeholder=""
            formControlName="utilityName"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputPrimarySvc">Primary Service</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputPrimarySvc"
            placeholder=""
            formControlName="primaryService"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputMeterNum">MeterNumber</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputMeterNum"
            placeholder=""
            formControlName="meterNumber"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputDateRequested">Date Requested</label>
          <div class="col-md-8">
            <input class="form-control"
              type="date"
              id="inputDateRequested"
              formControlName="dateRequested"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputRequester">Requester</label>
          <div class="col-md-8">
            <input class="form-control"
              type="text"
              id="inputRequester"
              formControlName="requester"/>
          </div>
        </div>
      </div>

      <!-------------------------------------------
              Late Utility Funding Adjustment
      --------------------------------------------->
      <div class="form-row form-group mb-2" formGroupName="lufaGroup"
          *ngIf= "this.manualUsageEventForm.get('usageType').value === usageEventTypes.lateUtilityFundingAdjustment">
        <div class="input-group mb-2">
        <label class="col-md-4 col-form-label" for="inputAccountNumber">AccountNumber</label>
        <div class="col-md-8">
          <input class="form-control"
          type="text"
          id="inputAccountNumber"
          placeholder=""
          formControlName="accountNumber"/>
        </div>
        </div>
      </div>

      <!-------------------------------------------
                Late Funding Info
      --------------------------------------------->
      <div class="form-row form-group mb-2" formGroupName="lfGroup"
      *ngIf= "this.manualUsageEventForm.get('usageType').value === usageEventTypes.lateFunding">
        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputConsolidationID">Consolidation Id</label>
          <div class="col-md-8">
            <input class="form-control"
            type="number"
            id="inputConsolidationID"
            placeholder=""
            formControlName="consolidationID"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputConsolidationInvNum">Invoice Number</label>
          <div class="col-md-8">
            <input class="form-control"
            type="number"
            id="inputConsolidationInvNum"
            placeholder=""
            formControlName="consolidationInvoiceNumber"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputBillConsolidatedOn">Consolidated On</label>
          <div class="col-md-8">
            <input class="form-control"
            type="Date"
            id="inputBillConsolidatedOn"
            placeholder=""
            formControlName="billConsolidatedOn"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputSrvDesciption">Service Description</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputSrvDesciption"
            placeholder=""
            formControlName="serviceDescription"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputConsodationFunded">Funded On</label>
          <div class="col-md-8">
            <input class="form-control"
            type="Date"
            id="inputConsodationFunded"
            placeholder=""
            formControlName="consolidationFunded"/>
          </div>
        </div>

        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputDaysToBill">Days To Bill</label>
          <div class="col-md-8">
            <input class="form-control"
            type="number"
            onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 45"
            id="inputDaysToBill"
            formControlName="daysToBill"
            [ngClass]="{'is-invalid': (manualUsageEventForm.get('lfGroup.daysToBill').touched && manualUsageEventForm.get('lfGroup.daysToBill').dirty) && !manualUsageEventForm.get('lfGroup.daysToBill').valid}">
            <span class="form-control-feedback"
            *ngIf="(manualUsageEventForm.get('lfGroup.daysToBill').touched || manualUsageEventForm.get('lfGroup.daysToBill').dirty) && !manualUsageEventForm.get('lfGroup.daysToBill').valid">
                <span *ngIf="this.manualUsageEventForm.get('lfGroup.daysToBill').errors['nonNumber']">Please enter a valid Integer.</span>
            </span>
          </div>
        </div>
      </div>

      <div class="form-row form-group mb-2">
        <div class="input-group mb-2">
          <label class="col-md-4 col-form-label" for="inputValue">Amount *</label>
          <div class="col-md-8">
            <input class="form-control"
            type="text"
            id="inputValue"
            formControlName="value"
            cbTwoDigitDecimaNumber
            [ngClass]="{'is-invalid': (manualUsageEventForm.get('value').touched || manualUsageEventForm.get('value').dirty) && manualUsageEventForm.get('value').invalid}"
            >
          <span class="form-control-feedback"
            *ngIf="(manualUsageEventForm.get('value').touched || manualUsageEventForm.get('value').dirty) && !manualUsageEventForm.get('value').valid">
            <span *ngIf="this.manualUsageEventForm.get('value').errors['required']">Please enter an amount.</span>
            <span *ngIf="this.manualUsageEventForm.get('value').errors['pattern']">Only 2 decimal digits are allowed please enter a valid number</span>

          </span>
          </div>
        </div>
      </div>

      <button class="btn btn-primary"
        type="submit"
        name="btnUsageSubmit"
        [title]="manualUsageEventForm.valid ? 'Save your entered Data': 'disabled until valid data entered'"
        [disabled]="!manualUsageEventForm.valid"
        (ngSubmit)="onSubmit()"> {{ (existingManualEvent ? "Update" : "Create") }}
      </button>


      <br>
      <br>
      <p class="text-muted"><small>* required fields</small></p>
    </form>
  </div>
